import React from 'react'

function Products() {
    return (
        <div>
        <h1 className="page-title">PRODUCTS</h1>
    </div>
    )
}

export default Products
